import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-show",
  "use": "icon-show-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-show\"><path d=\"M512 192c141.029 0 276.278 86.683 405.75 260.05l7.056 9.542c21.981 30.018 21.98 70.817-0.002 100.834C793.194 742.142 655.592 832 512 832c-141.028 0-276.277-86.677-405.748-260.03l-7.056-9.542c-21.982-30.017-21.983-70.816-0.002-100.834C230.805 281.864 368.407 192 512 192z m0 64c-120.119 0-240.5 78.618-361.17 243.406-4.946 6.754-5.44 15.691-1.613 22.706l1.436 2.262 6.876 9.299C276.015 692.319 394.108 768 512 768c120.12 0 240.5-78.613 361.17-243.387 4.946-6.754 5.44-15.692 1.613-22.706l-1.435-2.262-6.877-9.3C747.984 331.687 629.89 256 512 256z m0 96c88.366 0 160 71.634 160 160s-71.634 160-160 160-160-71.634-160-160 71.634-160 160-160z m0 64c-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96-42.98-96-96-96z\" p-id=\"2223\" fill=\"#707070\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/show.svg
// module id = 9Gww
// module chunks = 54